import { buildStrapiUrl, useStrapiConfig } from '~/composables/useStrapi'
import { fetchAllStrapi } from '~/utils/fetchAllStrapi'

export interface StrapiKitsListSummary {
  id: number
  title: string
  categorySlug: string | null
  pathSegment: string
}

function pathSegmentFromKitsSlug(fullSlug: string | undefined): string {
  if (!fullSlug) return ''
  if (fullSlug.includes('_')) return fullSlug.split('_')[0]
  return fullSlug
}

export const useStrapiKitsListSummaries = () => {
  const strapiConfig = useStrapiConfig()
  const config = useRuntimeConfig()
  const { locale } = useI18n()
  const strapiApiKey = config.public.strapiApiKey as string

  return useAsyncData(
    () => `kits-list-summaries-${locale.value}`,
    async () => {
      const params = new URLSearchParams()
      params.set('fields', 'title,slug,categorySlug')
      params.set('locale', locale.value)
      const href = buildStrapiUrl(
        strapiConfig,
        `kits-list-pages?${params.toString()}`
      )
      const rows = await fetchAllStrapi(href, strapiApiKey)
      return rows
        .map((item: any): StrapiKitsListSummary | null => {
          const pathSegment = pathSegmentFromKitsSlug(item.slug)
          if (!pathSegment || !item.title) return null
          return {
            id: item.id,
            title: item.title,
            categorySlug: item.categorySlug ?? null,
            pathSegment,
          }
        })
        .filter((x): x is StrapiKitsListSummary => x !== null)
    },
    { watch: [locale] }
  )
}
